import React from 'react';
import Slide from '../components/slide';
import Form from '../components/formReceitas';
import ReceitasPainel from '../components/receitasPainel';
import axios from 'axios';

class Receitas extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            nome:'',
            descricao:'',
            imagem_url:'',
            qtd_pessoas:'',
            calorias:'',
            tempo:'',
            ingredientes:'',
            como_fazer:''
        }
        this.handleChange = this.handleChange.bind(this);
        this.sendRecipe = this.sendRecipe.bind(this);
    }
    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }
    sendRecipe(e){
        e.preventDefault()
        const {nome, descricao, imagem_url, qtd_pessoas, calorias, tempo, ingredientes, como_fazer} = this.state
        axios.post('https://infinite-thicket-90676.herokuapp.com/receitanews', ({
            'nome': nome, 
            'descricao': descricao,
            'imagem_url': imagem_url,
            'qtd_pessoas': qtd_pessoas,
            'calorias': calorias,
            'tempo': tempo,
            'ingredientes': ingredientes,
            'como_fazer': como_fazer
        }))
        .then((res) => res.data())
    }
    render(){
        console.log(this.state)
        const {nome, descricao, imagem_url, qtd_pessoas, calorias, tempo, ingredientes, como_fazer} = this.state
        return(
            <div>
                <Slide/>
                <Form
                    nome = {nome}
                    descricao = {descricao}
                    imagem_url = {imagem_url}
                    qtd_pessoas = {qtd_pessoas}
                    calorias = {calorias}
                    tempo = {tempo}
                    ingredientes = {ingredientes}
                    como_fazer = {como_fazer}
                    onChange = {this.handleChange}
                    onClick = {this.sendRecipe}
                />
                <ReceitasPainel/>
            </div>
            
        )
    }
}

export default Receitas;